import React, { useContext, useState } from 'react'
import { EditOutlined, DeleteOutlined, SettingOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'

import { CourseContext } from '../Course/CourseContext'
import { FlexRow } from '../FlexboxReusables/FlexItems'
import Modal from '../Modal/Modal'
import { UserRole } from '../User/types'

interface CourseActionsProps {
  courseId: number
  role: UserRole
}

const CourseActions: React.FC<CourseActionsProps> = ({ courseId, role }) => {
  const [ showModal, setShowModal ] = useState(false)

  const { deleteCourse } = useContext(CourseContext)
  const intl = useIntl()

  const handleConfirmDelete = () => {
    deleteCourse(courseId, intl)
    setShowModal(false)
  }

  return (
    <>
      <Modal
        title={intl.formatMessage({ id: 'course.deleteCourse' }) + '?'}
        open={showModal}
        onOk={handleConfirmDelete}
        onCancel={() => setShowModal(false)}
        message={<FormattedMessage id="editor.settings.areYouSureYouWantToDelete"/>}
      />
      {role.toLowerCase() === UserRole.ADMIN && (
        <FlexRow justifyContent='space-evenly'>
          <Tooltip title={<FormattedMessage id="generic.settings" />}>
            <SettingOutlined key="setting" />
          </Tooltip>
          <Tooltip title={<FormattedMessage id="generic.edit" />}>
            <EditOutlined key="edit" />
          </Tooltip>
          <Tooltip title={<FormattedMessage id="course.deleteCourse" />}>
            <DeleteOutlined key="checkSquare" onClick={() => setShowModal(true)} />
          </Tooltip>
        </FlexRow>
      )}
    </>
  )
}

export default CourseActions
